require('./bootstrap');

// Imports
import Alpine from 'alpinejs';
import fslightbox from 'fslightbox';
require('aos/dist/aos.js');
import { createApp } from 'vue';

window.$ = require('jquery');

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

// Vue.js
import FemaleVideos from './components/FemaleVideos.vue';
import TestimonialVideos from './components/TestimonialVideos.vue';
import Reviews from './components/Reviews.vue';
import LandingpageReviews from './components/LandingpageReviews.vue';
import BeforeAfter from './components/BeforeAfter.vue';
import OverviewBeforeAfter from './components/OverviewBeforeAfter.vue';
import BeforeAfterSection from './components/BeforeAfterSection.vue';
import PatientBeforeAfter from './components/PatientBeforeAfter.vue'

// sliders
import BeforeAfterSlider from './components/sliders/before-after-slider.vue'
import FemaleVideosSlider from './components/sliders/female-videos-slider.vue'
import TestimonialVideosSlider from './components/sliders/testimonial-videos-slider.vue'

// modals
import BeforeAfterModal from './components/modals/before-after-modal.vue'

if(document.querySelector('#app') != null) {
  const app = createApp({});
  app.component('female-videos', FemaleVideos)
  app.component('testimonial-videos', TestimonialVideos)
  app.component('reviews', Reviews)
  app.component('landingpage-reviews', LandingpageReviews)
  app.component('before-after', BeforeAfter)
  app.component('overview-before-after', OverviewBeforeAfter)
  app.component('before-after-section', BeforeAfterSection)
  app.component('patient-before-after', PatientBeforeAfter)

  // sliders
  app.component('female-videos-slider', FemaleVideosSlider)
  app.component('testimonial-videos-slider', TestimonialVideosSlider)
  app.component('before-after-slider', BeforeAfterSlider)

  // modals
  app.component('before-after-modal', BeforeAfterModal)

  // Mount Vue.js app
  app.mount('#app')
}

// AlpineJs
window.Alpine = Alpine
Alpine.start()

// Lightbox instance
refreshFsLightbox();

// AOS
window.AOS = require('aos');
AOS.init({
  startEvent: 'DOMContentLoaded',
  easing: 'ease-in-sine',
  delay: 200,
  duration: 1000,
  once: false,
  mirror: true
});

// Swiper JS
if(document.querySelector('.frontpage-slider') != null) {
  const swiper = new Swiper('.frontpage-slider', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

if(document.querySelector('.testimonials-Swiper') != null) {
  var swiper5 = new Swiper('.testimonials-Swiper', {
    slidesPerView: 1,
    loop: true,
    centeredSlides: false,

    navigation: {
      nextEl: '.swiper-button-next',
    },

     breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
      }
    },
  });
}

if(document.querySelector('.associations-slider') != null) {
  const swiperAssociations = new Swiper('.associations-slider', {
    loop: true,
    slidesPerView: 1,
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
    },
  });
}

if(document.querySelector('.swiper-beforeAfterWrapper') != null) {
  const swiperbeforeAfterWrapper = new Swiper('.swiper-beforeAfterWrapper', {
    //disableOnInteraction: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 2000
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });


  let swipers = document.querySelectorAll('.swiper-beforeAfterWrapper')
  swipers.forEach(swiper => {
    swiper.swiper.autoplay.stop()

    $(".swiper-slide").mouseenter(function(e) {
      let closest = $(this).closest('.swiper-beforeAfterWrapper')[0]
      if (closest != undefined) {
        closest.swiper.autoplay.start()
      }
    });
  
    $(".swiper-slide").mouseleave(function(e) {
      let closest = $(this).closest('.swiper-beforeAfterWrapper')[0]
      if (closest != undefined) {
        closest.swiper.autoplay.stop()
      }
    });

    $(".swiper-slide").on('pointerenter', function(e) {
      let closest = $(this).closest('.swiper-beforeAfterWrapper')[0]
      if (closest != undefined) {
        closest.swiper.autoplay.start()
      }
    });

    $(".swiper-slide").click(function(e) {
      let closest = $(this).closest('.swiper-beforeAfterWrapper')[0]
      if (closest != undefined) {
        closest.swiper.autoplay.stop()
      }
    });
  })
}

if(document.querySelector('.swiper-video') != null) {
  const swiper5 = new Swiper('.swiper-video', {
    preventClicks: false,
    //preventClicksPropagation: false,
    draggable: false,
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    effect: 'slide',
    slidesPerGroup: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      992: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1400: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
    },
  });
}

if(document.querySelector('.swiper-video-testimonial') != null) {
  const swiper5 = new Swiper('.swiper-video-testimonial', {
    preventClicks: false,
    draggable: false,
    simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    effect: 'slide',
    slidesPerGroup: 1,
    loop: false,
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-test-button-next',
      prevEl: '.swiper-test-button-prev',
    },
    on: {
      transitionStart: function(){
        var videos = document.querySelectorAll('video');
        Array.prototype.forEach.call(videos, function(video){
          video.pause();
        });
      },
      // transitionEnd Funktion entfernt
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      992: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
      1400: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: false,
      },
    },
  });
}

if(document.querySelector('.swiper-beforeafter') != null) {
  const swiper4 = new Swiper('.swiper-beforeafter', {
    preventClicks: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    effect: 'slide',
    loop: true,
/*    autoplay: {
      delay: 4000,
    },*/
    resizeObserver: true,
    navigation: {
      nextEl: '.carousel-control-next',
      prevEl: '.carousel-control-prev',
    },
  });

}


// Start before & after modal slider autoplay on modal enter and stop on leave
$(document).ready(function() {
  if(document.querySelector('.swiper-beforeafter') != null) {
    var swiperAutoplayModal = document.querySelector('.swiper-beforeafter').swiper  
    
    $(".swiper-slide").mouseenter(function() {
      swiperAutoplayModal.autoplay.start();
    });

    $(".swiper-slide").mouseleave(function() {
      swiperAutoplayModal.autoplay.stop();
    });
  }
});

if(document.querySelector('.swiperOrinda') != null) {
  const swiperOrinda = new Swiper('.swiperOrinda', {
    preventClicks: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    effect: 'slide',
    loop: true,
    autoplay: {
      delay: 4000,
    },
    resizeObserver: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}


// Smooth scroll
document.querySelectorAll('.anchor')
.forEach(trigger => {
  trigger.onclick = function(e) {
    e.preventDefault();
    let hash = this.getAttribute('href');
    let target = document.querySelector(hash);
    let headerOffset = 100;
    let elementPosition = target.offsetTop;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  };
});

// Sticky Navigation
// var left = document.getElementById("navbarMobile");
// var stop = (left.offsetTop + 500);

// console.log(stop);

// window.onscroll = function (e) {
//   var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
//   //console.log(scrollTop, left.offsetTop);
//   // left.offsetTop;

//   if (scrollTop >= stop) {
//     //document.body.style.paddingTop = 68 + 'px';
//     left.className = 'navbar navbar-expand-xl navbar-dark sticky stick';
//   } else if (scrollTop <= stop) {
//     document.body.style.paddingTop = 0;
//     left.className = 'navbar navbar-expand-xl navbar-dark sticky';
//   }

// };

// Hide header on scroll down
const body = document.body;
const nav = document.getElementById("navbarMobile");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
const html = document.querySelector('html');
const navopen = document.querySelector(".navbar-toggler");
let lastScroll = 0;

navopen.addEventListener('click', () => {
  const isOpen = JSON.parse(navopen.getAttribute('aria-expanded'));
  
  if(isOpen)
    html.style.overflowY = "hidden";
  else
    html.style.overflowY = "auto";
});
 
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 76) {
    html.classList.remove(scrollUp);
    return;
  }
 
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    html.classList.remove(scrollUp);
    html.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    html.classList.contains(scrollDown)
  ) {
    // up
    html.classList.remove(scrollDown);
    html.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

// Coded by unlimited.studio – https://unlimited.studio